import { BackendModel, BackendService } from "../../../core/backend.service";

export class ProveedorCodigo extends BackendModel {
    codigoPlataforma: string;
}


// WEBPACK FOOTER //
// ./src/app/pedido/pedido-details/dtos/proveedor-codigo.ts